/**
 * [File::G_VariableText.js]
 *
 * @경로 : /public/scripts/game/lcPlugIn/canvas/grid/dev/child/graphic/G_VariableText.js
 * @목적 : 그리드에서 활용하기 위한 변수용 텍스트 객체
 * @설명 :
 * @진행 : 진행 중
 * @주의 :
 * @이슈 :
 * @일자 : 2018.08.17
 * @작성 : Lee Mi Reu
 * @참조 :
 */

import MixinBuilder from 'canvas/base/dev/scripts/MixinBuilder'
import B_Real from 'canvas/base/dev/child/base/B_Real'
import B_VariableText from 'canvas/base/dev/child/text/B_VariableText'
import B_ChildWorld from 'canvas/base/dev/child/base/B_ChildWorld'

let mix = (superclass) => new MixinBuilder(superclass)

const G_VariableText = (function () {
    class G_VariableText extends mix(B_Real).with(B_ChildWorld, B_VariableText) {}
    return G_VariableText
}())

export default G_VariableText



// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/grid/dev/child/text/G_VariableText.js